import authInstance from 'config/axios.config';

export const bannerServices = {

  // CREATE + UPLOAD BANNER
  uploadBannerImage: async (formData) => {

    const res = await authInstance.post(
      '/admin/ad-banner/upload',
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      }
    );

    return res.data;
  },

  // EDIT BANNER
updateBanner: async ({ bannerId, formData }) => {

  const res = await authInstance.patch(
    `/admin/ad-banner/${bannerId}`,
    formData,
    {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    }
  );

  return res.data;
},

  // GET BANNERS
  getBanners: async (filters) => {

    const params = new URLSearchParams();

    Object.entries(filters).forEach(([key, value]) => {

      if (
        value &&
        value !== 'all' &&
        value !== ''
      ) {
        params.append(key, String(value));
      }

    });

    const res = await authInstance.get(
      `/admin/listing/get-banner-images?${params}`
    );

    return res.data;
  },

  // DELETE
  deleteBanner: async (bannerId) => {

    const res = await authInstance.delete(
      `/admin/banner/${bannerId}`
    );

    return res.data;
  },
};